import React, { useEffect, useState } from "react"
import { ChevronRight } from "lucide-react"
import { queryTools } from "lib/utils"


export default function AddPreset({ dispute, addPresetFn }:{ dispute:any; addPresetFn:any }){

  const [ newPreset, setNewPreset ] = useState<any>({ subdomain: "", rp: "" })

  const handleInputChange = (e:any) => setNewPreset({ ...newPreset, [e.target.name]: e.target.value })
  const addNewPreset = (e:any) => {
    e.preventDefault()
    if( newPreset.subdomain && newPreset.rp ){
      addPresetFn(dispute, newPreset)
      setNewPreset({ subdomain: "", rp: "" }) // reset the form after submission
    }
  }

  return (
    <form onSubmit={addNewPreset}>
      <div className="w-full flex items-center gap-1 mt-1">
        <input 
          type="text" 
          name="rp" 
          value={newPreset.rp}
          onChange={handleInputChange}
          placeholder="rp" 
          autoComplete="off"
          className="w-3/12 h-6 text-xs border border-solid border-white/50 bg-transparent px-1 placeholder:px-1 placeholder-italic placeholder:opacity-55 focus:bg-transparent focus:outline-none focus:rounded-none active:bg-transparent active:outline-none active:rounded-none"
        />
        <input 
          type="text" 
          name="subdomain" 
          value={newPreset.subdomain}
          onChange={handleInputChange}
          placeholder="subdomain" 
          autoComplete="off"
          className="w-7/12 h-6 text-xs border border-solid border-white/50 bg-transparent px-1 placeholder:px-1 placeholder-italic placeholder:opacity-55 focus:bg-transparent focus:outline-none focus:rounded-none active:bg-transparent active:outline-none active:rounded-none" 
        />
        <button 
          type="submit"
          className="w-2/12 flex justify-center items-center h-6 stroke-1 cursor-pointer stroke-white border border-solid border-white/50 bg-yellow-500"
        >
          <ChevronRight className="w-4 h-4 stroke-2 stroke-teal-900" />
        </button>
      </div>
      
    </form>
  )
}